import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { checkErrors } from "helpers";

import { Stack } from '@mui/material';

import { Button } from "../Button";
import { TextField } from "../TextField";

import {
  selectAuthData,
  selectLoading,
  selectErrors,
  setErrors,
  updateAuthData,
  sendConfirm,
} from '../../authSlice';

export function Confirm() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector(selectLoading);
  const authData = useSelector(selectAuthData);
  const errors = useSelector(selectErrors);
  const { code: urlCode, email: urlEmail } = useParams();

  const handleSubmit = async () => {
    const formErrors = checkErrors(authData, [
      { name: "email", type: "email", required: true },
      { name: "confirmationCode", required: true },
    ]);

    dispatch(setErrors(formErrors));

    if (!Object.keys(formErrors).length) {
      const request = await dispatch(sendConfirm());

      if (request.meta.requestStatus !== "rejected") {
        navigate("/login");
      }
    }
  };

  const handleChangeField = (event) => {
    const name = event.target.id;
    let value = event.target.value;

    dispatch(updateAuthData({
      [name]: value.trim(),
    }));
  };

  useEffect(() => {
    dispatch(setErrors({}));
  }, [dispatch]);

  useEffect(() => {
    if (urlCode) {
      dispatch(updateAuthData({
        confirmationCode: urlCode.trim(),
      }));
    }

    if (urlEmail) {
      dispatch(updateAuthData({
        email: urlEmail.trim(),
      }));
    }
  }, [dispatch, urlCode, urlEmail]);

  return (
    <Stack
      direction="column"
      spacing={2}
    >
      <TextField
        error={!!errors.email}
        id="email"
        label="Email"
        helperText={errors.email}
        value={authData.email}
        onChange={handleChangeField}
      />
      <TextField
        error={!!errors.confirmationCode}
        id="confirmationCode"
        label="Код подтверждения"
        helperText={errors.confirmationCode}
        value={authData.confirmationCode}
        onChange={handleChangeField}
      />


      <Button
        onClick={handleSubmit}
        loading={loading}
        title="Подтвердить регистрацию"
      />
    </Stack>
  );
}
